import React, {useCallback, useEffect, useState} from 'react';
import {FiltersApi} from "../../services/services";
import Filter from "../components/Filter";
import {Card, CardBody, CardHeader, Col, Row} from "reactstrap";
import Buttons from "../components/buttons";

const Filters = (props) => {
    const [filters, setFilters] = useState([])
    const [data, setData] = useState({})
    const Filters = useCallback(async () => {
        const filter = await FiltersApi(props.subject)
        setFilters(filter?.data)
        console.log(filter?.data)
        if(filter?.data.length===0){
            props.onSetFilters(data)
        }
    })

    useEffect(() => {
        Filters()
    }, [])
    const onSetFilters = (filters) => {
        setData(filters)
    }
    return (
        <>
            <Col sm={12}>
                <Card className={"h-100"}>
                    <CardHeader>
                        <Row>
                            <Col className="text-right font-weight-600" sm="6">
                                <h5 className="card-category font-weight-600">فیلتر ها</h5>
                            </Col>
                        </Row>
                    </CardHeader>
                    <CardBody className={"text-center pointer"}>
                        {filters && <Filter
                            items={filters}
                            Filters={data}
                            onSetFilters={onSetFilters}
                        />}
                    </CardBody>
                </Card>
            </Col>
            <Col sm={12}>
                <Row className={"justify-content-center mt-4"}>
                    <Buttons
                        onSubmit={()=>props.onSetFilters(data)}
                        previousPage={props.previousPage}/>
                </Row>
            </Col>

        </>

    );
};

export default Filters;